import React from 'react';

// Custom Row component to replace @deere/ux.uxframe-react Row
const Row = ({ children, className = '', xs, sm, md, lg, xl, ...props }) => {
  const baseClasses = 'flex flex-wrap';
  const classes = `${baseClasses} ${className}`;
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Row;
